import store from 'store'
export default {
  // 用户信息
  saveUser(user) {
    store.set('users', user)
  },

  getUser() {
    return store.get('users') || {}
  },
 // 对样人信息
 saveWorkersUsers(WorkUsers) {
  store.set('wUsers', WorkUsers)
},

getWorkersUsers() {
  return store.get('wUsers') || {}
},
  removeUser() {
    store.remove('users')
  },
  // 成品检验单卷数据
  saveList(data) {
    store.set('list', data)
  },

  getList() {
    return store.get('list') || {}
  },

  removeList() {
    store.remove('list')
  },
  // 成品检验拼卷数据
  saveLists(data) {
    store.set('lists', data)
  },

  getLists() {
    return store.get('lists') || {}
  },

  removeLists() {
    store.remove('lists')
  },
  // 半成品检验拼卷数据
  savedataList(data) {
    store.set('dataList', data)
  },

  getdataList() {
    return store.get('dataList') || {}
  },

  removedataList() {
    store.remove('dataList')
  },
  // 检验员1
  savePerson(data) {
    store.set('person', data)
  },

  getPerson() {
    return store.get('person') || {}
  },

  removePerson() {
    store.remove('person')
  },
  // 检验员2
  savePerson2(data) {
    store.set('person2', data)
  },

  getPerson2() {
    return store.get('person2') || {}
  },

  removePerson2() {
    store.remove('person2')
  },
  // 检验员2
  saveDD(data) {
    store.set('DD', data)
  },

  getDD() {
    return store.get('DD') || []
  },

  removeDD() {
    store.remove('DD')
  },

  // 账号密码
  saveUserInfo(data) {
    store.set('userInfo', data)
  },

  getUserInfo() {
    return store.get('userInfo') || {}
  },

  removeUserInfo() {
    store.remove('userInfo')
  }
}